export default {
  FIR: "RayNeo AR Glasses Firmware Upgrade",
  NO: "Mobile device firmware upgrade is not supported for now",
  TIPS: "Please use the following browsers on your computer for firmware upgrade",
  pageTitle: "RayNeo AR Glasses Firmware Upgrade",
  connectStep: "Connect",
  updateStep: "Update",
  supportedModels:
    "Supported models: RayNeo GT, RayNeo GT MAX, RayNeo Air 4 Pro, RayNeo Air 4, RayNeo Air 3s Pro, RayNeo Air 3s, RayNeo Air 3, RayNeo Air 2s, RayNeo Air 2, RayNeo Air Plus, and RayNeo Air 1s.",
  desktopBrowserRequirement:
    "Use the desktop version of Chrome or Opera (version 89 or later).",
  singleDeviceRequirement:
    "Make sure only one pair of RayNeo glasses is connected to your computer during the update.",
  displayFlickerNotice:
    "Your display may briefly flicker after the glasses are connected. This is normal.",
  blackScreenReminder:
    "Friendly reminder: The screen will be black for about 15 seconds after the upgrade is complete before it lights up again. Please do not remove your glasses during the black screen process.",
  connectYourGlasses: "Connect Your Glasses",
  connectUsbInstruction:
    "Connect your glasses to a USB-C port on your computer, then click <strong>Connect Glasses</strong>.",
  selectDeviceInstruction:
    "When prompted, select your glasses from the device list and click <strong>Connect</strong>.",
  windowsConnectionHelp:
    "Having trouble connecting RayNeo Air Plus or Air 1s on Windows?",
  connectGlasses: "Connect Glasses",
  networkException:
    "Network exception. Please check your network and try again",
  windowsRecognitionTitle: "Rayneo Air plus and Air 1s cannot be recognized",
  windowsStepOne:
    '1. Press the Win+X keys simultaneously. In the pop-up menu, click "Device Manager", and a list of devices will be displayed.',
  windowsStepTwo:
    '2. If "STM32 DownLoad Firmware Update" is shown under "Other devices" in the device list, please select "STM32 Download Firmware Update", click <a href="https://zadig.akeo.ie/" target="_blank" rel="noopener noreferrer">zadig</a> to install the driver, and reconnect for recognition.',
  gotIt: "Got it",
  damagedFirmware: "The firmware is damaged. Please repair it in time.",
  currentFirmwareVersion: "Current firmware version {version}",
  latestFirmwareVersion: "It is already the latest firmware version.",
  newFirmwareAvailable:
    "A new firmware version {version} is available for upgrade.",
  details: "Details",
  newFirmwareInstructions: "New firmware version instructions",
  noInstructions: "No instructions available yet",
  repairFirmware: "Repair Firmware",
  upgradeFirmware: "Upgrade firmware",
  popupInstruction:
    "If a pop-up window appears during the update, please select your device in the pop-up window and click「Connect」.",
  fixingFirmware: "Fixing the firmware...",
  upgradingFirmware: "Upgrading the firmware...",
  doNotCloseDuringUpdate:
    "Do not close or refresh this page, or disconnect your glasses during the update.",
  firmwareRepairComplete: "Firmware repair complete",
  firmwareUpdateComplete: "Firmware update complete",
  firmwareCompleteDescription:
    "Your {model} is now running firmware version {version}.",
  rayneoGlasses: "RayNeo glasses",
  firmwareRepairFailed: "Firmware repair failed",
  firmwareOtaUpdateFailed: "Firmware OTA update failed",
  retryUpdate: "Re-update",
  repeatedProblems:
    "If you encounter problems repeatedly, please try unplugging the glasses, refreshing the page, and then operating again.",
  deviceDisconnected:
    "Device disconnected. Please check the connection and try again.",
  networkError: "Network error. Please check your network and try again.",
  firmwareUpdateFailedReconnect:
    "Firmware update failed. Please unplug and reconnect your glasses, then try again.",
  firmwareUpdateFailedSelect:
    "Firmware update failed. Please select your device and try again.",
  firmwareDownloadAddressEmpty:
    "Firmware download address is empty. Unable to update.",
  firmwareUpdateRequestFailed:
    "Firmware update request failed. Please check your network and try again.",
  singleDeviceDuringUpdate:
    "Please make sure only one RayNeo glasses is connected to the computer during the update process.",
  failedGetDeviceInformation:
    "Failed to get device information ({error}). Please refresh the page and try again.",
  deviceConnectionError:
    "Device connection error. Please unplug and reconnect your glasses, then try again.",
  browserUnsupported: "The current browser does not support firmware upgrade",
  openWithBrowsers: "Please open with the following browsers",
  browserVersionGreaterThan: "Version number is greater than {version}",
  mobileNotSupported: "Mobile device firmware upgrade is not supported for now",
  useComputerBrowsers:
    "Please use the following browsers on your computer for firmware upgrade",
  dfuPackageMismatch:
    "The .dfu files in the ZIP could not be matched with the device DFU interfaces. Please check the firmware package and the device.",
  firmwareDownloadFailed: "Failed to download firmware file.",
};
